//@import dependencies
import React, {useState, useEffect, Fragment} from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { store } from 'app_storage/redux-storage';
import { Form } from 'react-bootstrap'
import moment from 'moment';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import EditorJS from '@editorjs/editorjs';
import EditorJS from 'react-editor-js'
// @ts-ignore
import Embed from '@editorjs/embed'
// @ts-ignore
import Header from '@editorjs/header'
// @ts-ignore
import Image from '@editorjs/image'
// @ts-ignore
import LinkE from '@editorjs/link'
// @ts-ignore
import List from '@editorjs/list'
// @ts-ignore
import Paragraph from '@editorjs/paragraph'
// @ts-ignore
import Raw from '@editorjs/raw'
// @ts-ignore
import Checklist from '@editorjs/checklist'
// import EditorJS from 'react-editor-js'
//@end

// @import configs
import { external_api } from 'app_config/globals';
// @end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import PostTypeService from 'app_services/admin/post/postTypeService'
import PostCategoryService from 'app_services/admin/post/postCategoryService'
import PostLocationService from 'app_services/admin/post/postLocationService'
// @end

// @INFO Import Styles
import './../postModule.scss'

const Quote = require('@editorjs/quote');
const Table = require('@editorjs/table')

// @ADD Component types
interface IPostModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  viewer: boolean
}

const PostModuleLayout: React.FC<IPostModuleLayoutProps> = (props) => {

  const exampleData = {
    blocks: [{
      type: 'header',
      data: {
        text: 'Sin titulo',
        level: 2
      }
    }],
    time: new Date().getTime(),
    version: '2.19.0'
}

  const postTypeService: PostTypeService = new PostTypeService()
  const postCategoryService: PostCategoryService = new PostCategoryService()
  const postLocationService: PostLocationService = new PostLocationService()

  const [editorData, updateEditorData] = useState<undefined | any>(null)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [highlighted, setHighlighted] = useState<boolean>(false)
  const [listOfPostType, setListOfPostType] = useState<Array<any>>([])
  const [listOfPostCategory, setListOfPostCategory] = useState<Array<any>>([])
  const [listOfPostAuthors, setListOfPostAuthors] = useState<Array<any>>([])
  const [listOfPostLocationComplete, setListOfPostLocationComplete] = useState<Array<any>>([])
  const [listOfPostLocation, setListOfPostLocation] = useState<Array<any>>([])
  const [postTypeSelect, updatePostTypeSelect] = useState<string | null>(null)
  const [scheduleAdditionalInfo, setScheduleAdditionalInfo] = useState<any>(new Date());
  const [currentPostLocations, updateCurrentPostLocations] = useState<{value: string, label: string, name: string}[]>([]);

  const { t } = useTranslation()
  const formHook = useForm()
  const storeObject = store

  // Configuración del editor
  const EDITOR_TOOLS = {
    embed: {
      class: Embed,
      inlineToolbar: true
    },
    header: {
      class: Header,
      inlineToolbar: true
    },
    image: {
      class: Image,
      config: {
        endpoints: {
          byFile: `${external_api.backend.url}/api/admin/editor-js/image/upload-by-file`,
          byUrl: `${external_api.backend.url}/api/admin/editor-js/image/upload-by-url`
        },
        additionalRequestHeaders: {
          'Authorization': storeObject.getState().auth.user?.token ? storeObject.getState().auth.user?.token : ''
        },
        additionalRequestData: {
          // id: responseAPI ? responseAPI.academic_resource : ''
        }
      }
    },
    linkTool: {
      class: LinkE,
      config: {
        endpoint: `${external_api.backend.url}/api/admin/editor-js/link/fetch-url`
      }
    },
    quote: {
      class: Quote,
      inlineToolbar: true,
      shortcut: 'CMD+SHIFT+O',
      config: {
        quotePlaceholder: 'Enter a quote',
        captionPlaceholder: 'Quote\'s author',
      },
    },
    paragraph: {
      class: Paragraph,
      inlineToolbar: true
    },
    list: {
      class: List,
      inlineToolbar: true
    },
    raw: {
      class: Raw,
      inlineToolbar: true
    },
    checklist: {
      class: Checklist,
      inlineToolbar: true
    },
    table: {
      class: Table,
      inlineToolbar: true
    },
  }

  useEffect(() => {
    if (props?.editData) {
      setIsActive((props?.editData?.details?.isActive) ? props?.editData?.details?.isActive : false)
      setHighlighted((props?.editData?.details?.highlighted) ? props?.editData?.details?.highlighted : false)
      updateEditorData((props?.editData?.details?.content) ? props?.editData?.details?.content : null)
      if (props?.editData?.details?.postType) {
        updatePostTypeSelect(props?.editData?.details?.postType.name)
      }
      if (props?.editData?.details?.authors) {
        setListOfPostAuthors(props?.editData?.details?.authors.map((author: any) => {
          return {value: author, label: author}
        }))
      }

      if (props?.editData?.details?.additional_info?.schedule) {
        setScheduleAdditionalInfo(new Date(`1991-01-01 ${props?.editData?.details?.additional_info?.schedule}`))
      }

      // Guardar las ubicaciones actuales
      updateCurrentPostLocations(getDefaultValueLocations())
    } else {
      updateEditorData(exampleData)
    }
  }, [props,props.editData])

  useEffect(() => {
    getPostTypes()
    getPostCategories()
    getPostLocations()
  }, [])

  useEffect(() => {
    if (postTypeSelect) {
      handleLoadLocations(postTypeSelect)
    }
  }, [postTypeSelect, listOfPostLocationComplete])

  /**
   * @INFO Referencia del cambio del editor
   * @param data
   */
  const handleChangeEditor = (api: any, data?: any) => {
    if(data){
      if (data.blocks && data.blocks.length > 0) {
        updateEditorData(data)
      } else {
        updateEditorData(exampleData)
      }
    }
  }

  const getPostTypes = async () => {
    const types: Array<any> = []
    const postTypesResponse = await postTypeService.list()
    if (postTypesResponse) {
      postTypesResponse.postTypes.map((type: any) => {
        types.push({ value: type._id, label: `${type.description} - ${type.name}`  })
      })
    }
    setListOfPostType(types)
  }

  const getPostCategories = async () => {
    const categories: Array<any> = []
    const postCategoriesResponse = await postCategoryService.list()
    if (postCategoriesResponse) {
      postCategoriesResponse.postCategories.map((type: any) => {
        categories.push({ value: type._id, label: type.name })
      })
    }
    setListOfPostCategory(categories)
  }

  const getPostLocations = async () => {
    const locations: Array<any> = []
    const postLocationsResponse = await postLocationService.list()
    if (postLocationsResponse) {
      postLocationsResponse.postLocations.map((type: any) => {
        locations.push({ value: type._id, label: type.description, name: type.name })
      })
    }
    setListOfPostLocationComplete(locations)
  }

  const handleChangeIsActive = (e: any) => {
    setIsActive(!isActive)
  }
  const handleChangeHighlighted = (e: any) => {
    setHighlighted(!highlighted)
  }

  const handleChangePostType = (e: any) => {
    const type = e.label.split('-')[1].trim()
    updatePostTypeSelect(type)
    // handleLoadLocations(type)
  }

  const handleLoadLocations = (type: string) => {
    const locationsByPostType: any = {
      'news': ['guest', 'student', 'teacher', 'company'],
      'events': ['guest', 'live'],
      'research': ['guest', 'officials_landing'],
      'journal': ['guest', 'officials_landing'],
      'blog': ['guest'],
      'capsules': ['guest', 'officials_landing'],
      'webinar': ['guest', 'officials_landing'],
      'podcast': ['guest'],
    }
    if (locationsByPostType[type]) {
      const locations = listOfPostLocationComplete.filter((item) => locationsByPostType[type].includes(item.name))
      setListOfPostLocation(locations)
    }
  }

  /**
   * @INFO Unregister un campo del formulario
   * @param _fields
   */
  const unregisterField = (_fields: string[]) => {
    if(!_fields.length) return
    _fields.forEach((_field) => {
      formHook.unregister(_field)
    })
    return null
  }

  const getDefaultValueLocations = () => {
    if (props?.editData?.details?.locations?.length) {
      const _options = props?.editData?.details?.locations.map((r: any) => {
        return {
          value: r.postLocation._id,
          label: r.postLocation.description,
          name: r.postLocation.name
        }
      });
      return _options;
    } else {
      return [];
    }
  }

  return(
    <div className='post-form'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.posts.general_information")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12 switch-is-active">
              <div className="form-group">
                <Form.Check
                  type='switch'
                  id='isActive'
                  name='isActive'
                  label={t('labels.posts.isActive')}
                  onChange={(event: any) => handleChangeIsActive(event)}
                  checked={isActive}
                  ref={formHook.register()}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='postType'>{t('labels.posts.postType')}</label>
                <ReactSelectComponent
                  identifier='postType'
                  options={listOfPostType}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.postType) ? [{value: props?.editData?.details?.postType._id, label: `${props?.editData?.details?.postType.description} - ${props?.editData?.details?.postType.name}`}] : []}
                  isMulti={false}
                  required={true}
                  onChangeSelect={handleChangePostType}
                />
                {formHook.errors.postType && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            {postTypeSelect && (['news', 'research', 'journal', 'webinar', 'capsules', 'blog', 'podcast'].includes(postTypeSelect)) && (
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='postDate'>{t('labels.posts.postDate')}</label>
                  <input
                    type='date'
                    className='form-control'
                    name='postDate'
                    defaultValue={moment.utc(props?.editData?.details?.postDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                    ref={formHook.register({ required: true })}
                  />
                  {formHook.errors.postDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
            )}
            {postTypeSelect && postTypeSelect === 'events' && (
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='eventDate'>{t('labels.posts.eventDate')}</label>
                  <input
                    type='date'
                    className='form-control'
                    name='eventDate'
                    defaultValue={moment.utc(props?.editData?.details?.eventDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                    ref={formHook.register({ required: true })}
                  />
                  {formHook.errors.eventDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
            )}
            {postTypeSelect && (
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='locations'>{t('labels.posts.locations')}</label>
                  <ReactSelectComponent
                    identifier='locations'
                    options={listOfPostLocation}
                    formHooks={formHook}
                    defaultValue={getDefaultValueLocations()}
                    isMulti={true}
                    required={true}
                    onChangeSelect={(data: any) => updateCurrentPostLocations(data ? data : [])}
                  />
                  {formHook.errors.locations && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
            )}
          </div>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.posts.post_content")}</h3>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className='form-group '>
                <label htmlFor='title'>{t('labels.posts.title')}</label>
                {formHook.errors.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='title'
                  name='title'
                  className={`form-control ${formHook.errors.title && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.title}
                />
              </div>
            </div>
            {postTypeSelect && !['journal'].includes(postTypeSelect) &&(
              <div className="col-md-6">
                <div className='form-group '>
                  <label htmlFor='subtitle'>{t('labels.posts.subtitle')}</label>
                  {formHook.errors.subtitle && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <textarea
                    id='subtitle'
                    name='subtitle'
                    className={`form-control ${formHook.errors.subtitle && 'is-invalid'}`}
                    ref={formHook.register({ required: true })}
                    defaultValue={props?.editData?.details?.subtitle}
                  ></textarea>
                </div>
              </div>
            )}

            {postTypeSelect && ['webinar', 'capsules', 'podcast', 'research', 'journal', 'news'].includes(postTypeSelect) &&
              <>
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor='authors'>{t('labels.posts.authors')}</label>
                    <ReactSelectComponent
                      identifier='authors'
                      isCreatable={true}
                      options={listOfPostAuthors}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.authors) ? props?.editData?.details?.authors.map((r: any) => {return {value: r, label: r}}) : []}
                      isMulti={true}
                      required={false}
                    />
                  </div>
                </div>
              </>
            }

            {/* ================= Campos de video =============== */}
            {postTypeSelect === 'webinar' || postTypeSelect === 'capsules' || postTypeSelect === 'podcast' || currentPostLocations?.find((l) => l.name === 'live') ?
              <>
                <div className="col-md-6">
                  <div className='form-group '>
                    <label htmlFor='platform_video'>{t('labels.posts.platform_video')}</label>
                    {formHook.errors.platform_video && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <ReactSelectComponent
                      identifier='platform_video'
                      options={[{ label: 'youtube', value: 'youtube' }, {label: 'web', value: 'web'}]}
                      formHooks={formHook}
                      defaultValue={(props?.editData?.details?.video?.platform) ? [{ value: props?.editData?.details?.video?.platform, label: props?.editData?.details?.video?.platform }] : []}
                      isMulti={false}
                      required={true}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className='form-group '>
                    <label htmlFor='url_video'>{t('labels.posts.url_video')}</label>
                    {formHook.errors.url_video && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='url_video'
                      name='url_video'
                      className={`form-control ${formHook.errors.url_video && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: true })}
                      defaultValue={props?.editData?.details?.video?.url}
                    />
                  </div>
                </div>
              </>
            : unregisterField(['platform_video', 'url_video']) }
            {/* ================= Contenido =============== */}
            {postTypeSelect === 'news' || postTypeSelect === 'events' || postTypeSelect === 'blog' ?
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='content'>{t('labels.posts.content')}</label>
                <input
                  id="content"
                  type="hidden"
                  name="content"
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.subtitle}
                  value={(editorData) ? JSON.stringify(editorData) : ''}
                />
                {editorData && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorData}
                    // readOnly={!editState}
                    onChange={handleChangeEditor}
                    autofocus={true}
                  />
                )}
                {formHook.errors.content && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            : unregisterField(['content']) }
            {/* ================== Archivo de articulo ==================== */}
            {postTypeSelect === 'research' || postTypeSelect === 'journal' ?
              <div className="col-md-6">
                <div className='form-group'>
                  <label htmlFor='researchFile'>{postTypeSelect === 'journal' ? 'Boletín' : t('labels.posts.researchFile')}</label>
                  {formHook.errors.researchFile && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='researchFile'
                    name='researchFile'
                    className='form-control-file'
                    type='file'
                    ref={formHook.register({ required: false })}
                  />
                  {formHook.errors.researchFile && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
            : unregisterField(['researchFile']) }

            <div className="col-md-6">
              <div className='form-group'>
                <label htmlFor='cover'>{t('labels.posts.cover')}</label>
                {formHook.errors.cover && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='cover'
                  name='cover'
                  className='form-control-file'
                  type='file'
                  ref={formHook.register({ required: false })}
                />
                {formHook.errors.cover && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            {props?.editData?.details?.coverUrl && (
              <div className="col-md-6">
                <div className="form-group">
                    <div className="cover-container">
                      <img src={props?.editData?.details?.coverUrl} alt=""/>
                    </div>
                </div>
              </div>
            )}

            {postTypeSelect && ['events', 'news'].includes(postTypeSelect) &&
              <>
                <div className="col-md-12">
                  <div className="form-group">
                  <label htmlFor='cover_caption'>{t('labels.posts.cover_caption')}</label>
                    {formHook.errors.cover_caption && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='cover_caption'
                      name='cover_caption'
                      className={`form-control ${formHook.errors.cover_caption && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: false })}
                      defaultValue={props?.editData?.details?.cover_caption}
                    />
                  </div>
                </div>
              </>
            }

            {postTypeSelect && ['events'].includes(postTypeSelect) &&
              <>
                <div className="col-md-6">
                  <div className="form-group">
                  <label htmlFor='additional_info[country]'>{t('labels.posts.additional_info.country')}</label>
                    {formHook.errors?.additional_info?.country && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='additional_info[country]'
                      name='additional_info[country]'
                      className={`form-control ${formHook.errors.additional_info?.country && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: false })}
                      defaultValue={props?.editData?.details?.additional_info?.country}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                  <label htmlFor='additional_info[location]'>{t('labels.posts.additional_info.location')}</label>
                    {formHook.errors?.additional_info?.location && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='additional_info[location]'
                      name='additional_info[location]'
                      className={`form-control ${formHook.errors.additional_info?.location && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: false })}
                      defaultValue={props?.editData?.details?.additional_info?.location}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group additional-info-schedule-input">
                    <label htmlFor='additional_info[schedule]'>{t('labels.posts.additional_info.schedule')}</label>
                    <input
                      type="hidden"
                      name="additional_info[schedule]"
                      defaultValue={moment(scheduleAdditionalInfo).format('h:mm a')}
                      ref={formHook.register({ required: false })}
                    />
                    <DatePicker
                      selected={scheduleAdditionalInfo}
                      onChange={(date) => setScheduleAdditionalInfo(date)}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Hora"
                      dateFormat="h:mm a"
                    />
                  </div>
                </div>
                {/* <div className="col-md-6">
                  <div className="form-group ">
                  <label htmlFor='additional_info[schedule]'>{t('labels.posts.additional_info.schedule')}</label>
                    {formHook.errors?.additional_info?.schedule && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='additional_info[schedule]'
                      name='additional_info[schedule]'
                      className={`form-control ${formHook.errors.additional_info?.schedule && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: false })}
                      defaultValue={props?.editData?.details?.additional_info?.schedule}
                    />
                  </div>
                </div> */}
                <div className="col-md-6">
                  <div className="form-group">
                  <label htmlFor='additional_info[modality]'>{t('labels.posts.additional_info.modality')}</label>
                    {formHook.errors?.additional_info?.modality && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='additional_info[modality]'
                      name='additional_info[modality]'
                      className={`form-control ${formHook.errors.additional_info?.modality && 'is-invalid'}`}
                      type='text'
                      ref={formHook.register({ required: false })}
                      defaultValue={props?.editData?.details?.additional_info?.modality}
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <div className='form-group'>
                        <label htmlFor='brochure'>{t('labels.posts.brochure')}</label>
                        {formHook.errors.brochure && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                        <input
                          id='brochure'
                          name='brochure'
                          className='form-control-file'
                          type='file'
                          ref={formHook.register({ required: false })}
                        />
                        {formHook.errors.brochure && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      </div>
                    </div>
                    {props?.editData?.details?.brochureUrl && (
                      <div className="col-md-6">
                        <div className="form-group">
                            <div className="cover-container">
                              <img src={props?.editData?.details?.brochureUrl} alt=""/>
                            </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            }
          </div>

          {postTypeSelect && !['journal'].includes(postTypeSelect) &&
            <Fragment>
              <div className="d-flex align-items-center mb-2">
                <h3 className="form-title">{t("modules.posts.post_configuration")}</h3>
              </div>


              <div className="row">

                {postTypeSelect && ['news'].includes(postTypeSelect) && (
                  <div className="col-md-12">
                    <div className="form-group">
                      <Form.Check
                        type='switch'
                        id='highlighted'
                        name='highlighted'
                        label={t('labels.posts.highlighted')}
                        onChange={(event: any) => handleChangeHighlighted(event)}
                        checked={highlighted}
                        ref={formHook.register()}
                      />
                    </div>
                  </div>
                )}

                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor='startDate'>{t('labels.posts.startDate')}</label>
                    <input
                      type='datetime-local'
                      className='form-control'
                      name='startDate'
                      // defaultValue={moment.utc(props?.editData?.details?.startDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                      defaultValue={moment(props?.editData?.details?.startDate).format('YYYY-MM-DD HH:mm').replace(' ', 'T') || moment().format('YYYY-MM-DD HH:mm').replace(' ', 'T')}
                      ref={formHook.register({ required: false })}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor='endDate'>{t('labels.posts.endDate')}</label>
                    <input
                      type='datetime-local'
                      className='form-control'
                      name='endDate'
                      // defaultValue={moment.utc(props?.editData?.details?.endDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                      defaultValue={moment(props?.editData?.details?.endDate).format('YYYY-MM-DD HH:mm').replace(' ', 'T') || moment().format('YYYY-MM-DD HH:mm').replace(' ', 'T')}
                      ref={formHook.register({ required: false })}
                    />
                  </div>
                </div>

                {postTypeSelect && ['research', 'blog', 'capsules', 'webinar', 'podcast', 'news', 'events'].includes(postTypeSelect) && (
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor='tags'>{t('labels.posts.tags')}</label>
                      <ReactSelectComponent
                        identifier='tags'
                        isCreatable={true}
                        options={listOfPostCategory}
                        formHooks={formHook}
                        defaultValue={(props?.editData?.details?.tags) ? props?.editData?.details?.tags.map((r: any) => {return {value: r._id, label: r.name}}) : []}
                        isMulti={true}
                        required={false}
                      />
                    </div>
                  </div>
                )}


              </div>
            </Fragment>
          }

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit'>
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}

        </form>
      </fieldset>
    </div>
  )
}

export default PostModuleLayout
